import { routerRedux } from 'dva/router';
import qs from 'qs';
import React from 'react';
import {
  getProviderFactory,
  globalDispatch,
  NotificationUtil,
  SMessageBox,
} from 'slipstream-components';
import DefaultAuthProvider from '../adapter/providers/DefaultAuthProvider';

const ContextUtil = {
  getToken() {
    return getProviderFactory()
      .getAuthProvider()
      .getToken();
  },

  getRoleScope(): 'Enterprise' | 'OpCo' | 'SP' {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getRoleScope();
  },

  getUserName() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getUserName();
  },

  getUserId() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getUserId();
  },

  getTenantUuid() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTenantUuid();
  },
  getTenant() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTenant();
  },
  getTenantDisplayName() {
    const tenantName = ContextUtil.getTenant();
    if (ContextUtil.getRoleScope() === 'Enterprise' && tenantName.indexOf('__') !== -1) {
      return tenantName.substr(0, tenantName.indexOf('__'));
    }
    return tenantName;
  },
  getTenantId() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTenantId();
  },
  getFeatures() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getFeatures();
  },
  getTenantProperties(): any {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTenantProperties();
  },
  getCustomerUuid() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getCustomerId();
  },
  getCustomer() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getCustomer();
  },
  getCapabilities() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getCapabilities();
  },
  getTokenExpiredAt() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTokenExpireAt();
  },
  getTokenIssueAt() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTokenIssueAt();
  },
  getAuthenticationMode() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getAuthenticationMode();
  },
  getSseToken() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getSseToken();
  },
  renewToken(password: string) {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).renewToken(password);
  },
  renewTokenWithTotp(authData: object) {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).renewTokenWithTotp(
      authData
    );
  },
  isMobile() {
    const mobileFlag = sessionStorage.getItem('mobile');
    if (typeof mobileFlag !== 'undefined') {
      return sessionStorage.getItem('mobile');
    } else {
      return false;
    }
  },

  setTenantProperties(props: any) {
    (getProviderFactory().getAuthProvider() as DefaultAuthProvider).setTenantProperties(props);
  },
  setProjects(projs) {
    (getProviderFactory().getAuthProvider() as DefaultAuthProvider).setProjects(projs);
  },

  guid() {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  },

  getDomain() {
    return 'default-domain';
  },

  getProjects() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getProjects();
  },

  getLoginRoleScope() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getLoginRoleScope();
  },

  tenantSwitched() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).tenantSwitched();
  },

  getTokenDetail() {
    return (getProviderFactory().getAuthProvider() as DefaultAuthProvider).getTokenDetail();
  },
};

const JobUtil = {
  registeredInfo: {},
  subscribed: false,

  showJobDetail: (uuid: string) => {
    const popupJobDetail = () => {
      (window as any).g.app._store.dispatch({
        type: 'jobs/show',
        payload: {
          jobUuid: uuid,
        },
      });
    };
    return popupJobDetail;
  },
  openJobDetail: (uuid: string) => {
    (window as any).g.app._store.dispatch({
      type: 'jobs/show',
      payload: {
        jobUuid: uuid,
      },
    });
  },

  jobCallback(topic: string, msg: any) {
    if (msg.oper === 'UPDATE') {
      const jobUuid = msg.uuid;
      const jobName = this.registeredInfo[jobUuid];
      if (jobName && msg.updated_props) {
        const state = msg.updated_props.status;
        if (state === 'success') {
          delete this.registeredInfo[jobUuid];
          setTimeout(() => {
            SMessageBox.success(
              <span>
                {jobName} job successfully completed, click{' '}
                <a href="#" onClick={this.showJobDetail(jobUuid)}>
                  here
                </a>{' '}
                to view job details.
              </span>
            );
          }, 7000);
        } else if (state === 'failed') {
          SMessageBox.error(
            <span>
              {jobName} job failed, click{' '}
              <a href="#" onClick={this.showJobDetail(jobUuid)}>
                here
              </a>{' '}
              to view job details.
            </span>
          );
          delete this.registeredInfo[jobUuid];
        }
      }
    }
  },
  registerJob(jobName: string, jobId?: string) {
    if (jobId) {
      SMessageBox.success(
        <span>
          {jobName} job was created, click{' '}
          <a href="#" onClick={this.showJobDetail(jobId)}>
            here
          </a>{' '}
          to view job details.
        </span>
      );
    } else {
      SMessageBox.success(<span>{jobName} job was created.</span>);
    }

    this.registeredInfo[jobId] = jobName;
    if (this.subscribed === false) {
      NotificationUtil.getInstance().subscribe(['job-service:job'], this.jobCallback.bind(this));
      this.subscribed = true;
    }
  },

  registerScheduleById(name: string, scheduleId) {
    SMessageBox.success(
      <span>
        {name} was successfully scheduled, click{' '}
        <a
          href="#"
          onClick={() => {
            globalDispatch(
              routerRedux.push('/monitor/jobs?tab_key=scheduled&filters=eq:uuid:' + scheduleId)
            );
          }}
        >
          here
        </a>{' '}
        to view details.
      </span>
    );
  },
};

const Util = {
  trimLines(content: string) {
    const lines = content.split(/(?:\r\n|\n|\r)/);
    const newLines = [];
    lines.forEach(line => {
      if (line) {
        newLines.push(line.trim());
      }
    });
    return newLines.join('\r\n');
  },
  getUrlParams() {
    return qs.parse(window.location.search.substring(1));
  },
  /**
   * navigate to specified url, this will add history to browser and user can click 'back' to the original url.
   * @param url
   */
  navigateTo(url) {
    globalDispatch(routerRedux.push(url));
  },

  /**
   * navigate to specified url, this will replace the current history from browser.
   * @param url
   */
  navigateToByReplace(url) {
    globalDispatch(routerRedux.replace(url));
  },

  /**
   * navigate to specified url, this will first check the url is the same as previous page, if so, replace, else, push.
   * @param url
   */
  navigateToByReplaceFirst(url) {
    throw new Error('Not implemented yet');
  },

  /**
   * get tenant display name from fq_name
   * @param fqName fq_name
   */
  getTenantNameFromFQName(fqName: string[]) {
    if (Array.isArray(fqName) && fqName.length > 1) {
      const tenantName = fqName[1];
      if (tenantName.indexOf('__') !== -1) {
        return tenantName.substring(0, tenantName.indexOf('__'));
      } else {
        return tenantName;
      }
    }
  },
};

const GlobalUtil = {
  navigateTo(url: string) {
    globalDispatch(routerRedux.push(url));
  },
};

const AppUtil = {
  context: ContextUtil,
  job: JobUtil,
  global: GlobalUtil,
  util: Util,
};

export default AppUtil;
